import React from 'react';

import { Box, Button, Text } from '@betterment/samba-react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import StepHeading from '../../../AccountCreationFlow/components/StepHeading';
import { WorkflowLayout } from '../../../Shared/layout/WorkflowLayout';
import { useSdiAccountStep } from '../SdiAccountFlow';

export const AccountConfirmation: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');

  const { values } = useSdiAccountStep('ownership');
  const ownershipType = values?.ownershipType;

  const handleButtonClick = () => {
    alert('You did it!');
  };

  return (
    <WorkflowLayout
      pageTitle="Confirmation"
      workflowTitle=""
      onBack={() => navigate(-1)}
      onClose={() => (returnTo ? navigate(returnTo) : navigate('/'))}
    >
      <Box css={{ display: 'grid', gap: 'space.300' }}>
        <StepHeading>Your account is ready!</StepHeading>
        <Text>Account type: {ownershipType}</Text>
        <Box css={{ display: 'flex' }}>
          <Button onClick={handleButtonClick} variant="solidPrimary">
            Open my account
          </Button>
        </Box>
      </Box>
    </WorkflowLayout>
  );
};
